import React from "react";
import "./confirm.scss";
import SubmitButton from "../submitButton/submitButton";
function Confirm({ message, display, onConfirm, onCancel, loading }) {
  return display ? (
    <div className="confirmWrapper">
      <div className="dialogBox">
        {message}
        <div className="buttons">
          {/* <button onClick={() => onConfirm()}>بله</button> */}
          <SubmitButton
            text="بله"
            loading={loading}
            onClick={() => onConfirm()}
          />

          <button onClick={() => onCancel()}>خیر</button>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
export default Confirm;
